import { Action } from '@ngrx/store';
import { SearchRequest } from 'src/app/shared/models/searchers';
import { IAuthTable } from '../auth.interfaces';

export enum SearcherAuthActionTypes {
    SEARCHER_LOGIN = '[SearcherAuth] Searcher Login',
    SEARCHER_LOGIN_SUCCESS = '[SearcherAuth] Searcher Login Success',
    SEARCHER_LOGIN_SUCCESS_REDIRECT = '[SearcherAuth] Searcher Login Success Redirect',
    SEARCHER_LOGIN_FAILURE = '[SearcherAuth] Searcher Login Failure',
    SEARCHER_REFRESH_TOKEN = '[SearcherAuth] Searcher Refresh Token',
    SEARCHER_REFRESH_TOKEN_SUCCESS = '[SearcherAuth] Searcher Refresh Token Success',
    SEARCHER_REFRESH_TOKEN_FAILURE = '[SearcherAuth] Searcher Refresh Token Failure',
    SEARCHER_LOGOUT = '[SearcherAuth] Searcher Logout',
    SEARCHER_DISPLAY_ERROR = '[SearcherAuth] Searcher Display Error',
    SEARCHER_FORGOT_PASSWORD = '[SearcherAuth] Searcher Forgot Password',
    SEARCHER_FORGOT_PASSWORD_COMPLETE = '[SearcherAuth] Searcher Forgot Password Complete',
    SEARCHER_FORGOT_PASSWORD_ERROR = '[SearcherAuth] Searcher Forgot Password Error',
    SEARCHER_CHECK_LOGIN_FAILURE = '[SearcherAuth] Searcher Check Login Failure',
    SEARCHER_RESET_PASSWORD_COMPLETE = '[SearcherAuth] Searcher Reset Password Complete',
    SEARCHER_CHECK_LOGIN = '[SearcherAuth] Check Login',
    SEARCH_REQUEST = '[SearcherAuth] Searcher Search Request',
    SEARCH_REQUEST_SUCCESS = '[SearcherAuth] Searcher Search Request Success',
    SEARCH_REQUEST_FAILURE = '[SearcherAuth] Searcher Search Request Failure'
}


export class SearcherLogin implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_LOGIN;
    constructor(public payload: { userName: string; password: string, strataPlanNumber: string }) { }
}

export class SearcherLoginSuccess implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_LOGIN_SUCCESS;
    constructor(public payload: IAuthTable) { }
}

export class SearcherLoginFailure implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_LOGIN_FAILURE;
    constructor(public payload: string) { }
}
export class SearcherLoginSuccessRedirect implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_LOGIN_SUCCESS_REDIRECT;
}

export class SearcherRefreshToken implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_REFRESH_TOKEN;
}

export class SearcherRefreshTokenSuccess implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_REFRESH_TOKEN_SUCCESS;
    constructor(public payload: IAuthTable) { }
}

export class SearcherRefreshTokenFailure implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_REFRESH_TOKEN_FAILURE;
    constructor(public payload: string) { }
}

export class SearcherDisplayError implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_DISPLAY_ERROR;
    constructor(public payload: string) { }
}

export class SearcherLogout implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_LOGOUT;
}


export class SearcherForgotPassword implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_FORGOT_PASSWORD;
    constructor(public payload: string) { }
}

export class SearcherForgotPasswordComplete implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_FORGOT_PASSWORD_COMPLETE;
}

export class SearcherForgotPasswordError implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_FORGOT_PASSWORD_ERROR;
    constructor(public payload: string) { }
}

export class SearcherCheckLogin implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_CHECK_LOGIN;
}

export class SearcherCheckLoginFailure implements Action {
    readonly type = SearcherAuthActionTypes.SEARCHER_CHECK_LOGIN_FAILURE;
}

export class SearcherSearchRequest implements Action {
    readonly type = SearcherAuthActionTypes.SEARCH_REQUEST;
    constructor(public payload: SearchRequest) { }
}

export class SearcherSearchRequestSuccess implements Action {
    readonly type = SearcherAuthActionTypes.SEARCH_REQUEST_SUCCESS;
    constructor(public payload: any) { }
}

export class SearcherSearchRequestFailure implements Action {
    readonly type = SearcherAuthActionTypes.SEARCH_REQUEST_FAILURE;
    constructor(public payload: any) {}
  }

export type SearcherAuthActions = SearcherLogin
    | SearcherLoginSuccess
    | SearcherLoginFailure
    | SearcherLoginSuccessRedirect
    | SearcherRefreshToken
    | SearcherRefreshTokenSuccess
    | SearcherRefreshTokenFailure
    | SearcherDisplayError
    | SearcherLogout
    | SearcherForgotPassword
    | SearcherForgotPasswordComplete
    | SearcherForgotPasswordError
    | SearcherCheckLogin
    | SearcherCheckLoginFailure
    | SearcherSearchRequest
    | SearcherSearchRequestSuccess
    | SearcherSearchRequestFailure;
